'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module3Res7 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Res7, _Component);

  function Module3Res7() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Res7);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Res7.__proto__ || (0, _getPrototypeOf2.default)(Module3Res7)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Time out principles'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3Res7, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'h3',
                  null,
                  '1. Stay calm'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Time-out means ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'time away from your attention. '
                  ),
                  'Any attention, even bad attention (eg. yelling) can strengthen the misbehaviour.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  '2. Have plenty of \'time-in\''
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'It is important that you ensure that you and your child have ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'positive times '
                  ),
                  'interacting together. Without \'time-in\', a time-out loses its effectiveness.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  '3. Keep it short (1-2 mins per year of age)'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'If the time-out is too long, the child will forget the reason they are there and will not learn anything. Lots of ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'short \'timeouts\''
                  ),
                  ' are best.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  '4. When it\'s over, it is over'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Instead of reminding your child about their bad behaviour, ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'focus on the positive. '
                  ),
                  'Instead of \'I\'m glad you\'ve stopped shouting\' try \'what do you want to play with now?\''
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  '5. Do not threaten, act'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Time-outs are most effective when parents use them ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'immediately after bad behaviour '
                  ),
                  'and when they use them ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'consistently'
                  ),
                  '. Children need to learn that bad behaviour will always have a consequence ie. time-out.'
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module3Res7;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3Res7;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Res7.js
// module id = 1253
// module chunks = 0